module.exports = __webpack_public_path__ + "img/cartilha-ciclista.bd633c6c.jpg";